import { useCallback } from "react";
import { useSelector } from "react-redux";
import { selectPermissions } from "@/features/auth/authSlice";
import { hasPermission } from "@/features/auth/permissions";

/**
 * `can(PERMISSIONS.DELETE_INVOICE)` — used to gate buttons and nav items.
 * Returns a stable callback so it can sit in dependency arrays.
 */
export function useHasPermission() {
  const permissions = useSelector(selectPermissions);

  return useCallback(
    (requiredGuid) => hasPermission(permissions, requiredGuid),
    [permissions],
  );
}
